import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { useSelector } from "react-redux";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import {
  getMoreNews,
  getNews,
  selectCanLoadMore,
  selectLoading,
  selectNews,
  selectPageSize,
} from "./DevelopmentNewsSlice";
import { useEffect, useState } from "react";
import "./DevelopmentNewsList.scss";
import { Link } from "react-router-dom";
import { sanitizeHtml } from "cpl-react-common/Helpers/HtmlSanitizerHelpers";

const DevelopmentNewsList: React.FC = () => {
  const thunkDispatch = useThunkDispatch();
  const news = useSelector(selectNews);
  const [filteredNews, setFilteredNews] = useState(news);
  const loadingNews = useSelector(selectLoading);
  const [pageIndex, setPageIndex] = useState(0);
  const pageSize = useSelector(selectPageSize);
  const canLoadMore = useSelector(selectCanLoadMore);

  useEffect(() => {
    thunkDispatch(getNews({ pageSize }));
  }, [thunkDispatch, pageSize]);

  const loadMoreNews = () => {
    const nextPage = pageIndex + 1;
    setPageIndex(nextPage);
    thunkDispatch(getMoreNews({ index: nextPage, pageSize: pageSize }));
  };

  useEffect(() => {
    if (news !== undefined && news?.length > 0) {
      setFilteredNews(news.slice(0, (pageIndex + 1) * 10));
    }
  }, [news, pageIndex]);

  return (
    <div className="card d-flex mt-4 cpl-table-container">
      <ActivityIndicator isBusy={loadingNews}>
        <div className="card-body overflow-scroll news-list-container">
          {filteredNews?.map((n, index) => {
            return (
              <>
                <div
                  className="card-body d-flex flex-column flex-md-row px-0 px-md-3 py-2 my-4 h-auto  mh-md-225px position-relative"
                  key={index}
                >
                  <Link
                    data-test-id={`development-news-list__view-post-link-${n?.developmentNewsID}`}
                    className="stretched-link"
                    to={`/news/${n?.developmentNewsID}`}
                  />
                  <div className="d-flex flex-column news-list-content w-100 h-auto h-md-100">
                    <div className="h5">{n.title}</div>
                    <div className="news-body" dangerouslySetInnerHTML={{ __html: sanitizeHtml(n.body) }}></div>
                    <div className="d-flex justify-content-between align-items-center mt-8">
                      <h6 className="me-auto">Date: {n.postedOn?.toCPLCommentDateTimeString()}</h6>
                      <button
                        data-test-id={`development-news-list__view-post-button-${n?.developmentNewsID}`}
                        className="cpl-btn cpl-btn-primary d-flex justify-content-center align-items-center"
                      >
                        View
                      </button>
                    </div>
                  </div>
                  <div className="news-list-image-container d-flex justify-content-center align-items-center order-first order-md-0 ms-0 ms-md-2 p-0 p-md-4 w-100 h-auto h-md-100 mb-3">
                    <img
                      className="news-list-image w-100 mh-175px mh-md-unset object-fit-contain"
                      alt="news post"
                      src={n.imagePath != undefined ? n.imagePath : "/media/property-placeholder.jpg"}
                    ></img>
                  </div>
                </div>
                <div className="separator separator-dashed mb-3"></div>
              </>
            );
          })}
          {canLoadMore && (
            <ActivityIndicator isBusy={loadingNews}>
              <Link
                data-test-id="development-news-list__load-more-button"
                className="d-flex justify-content-center align-items-center cpl-link fw-bolder fs-5"
                to=""
                onClick={(e) => {
                  e.preventDefault();
                  loadMoreNews();
                }}
              >
                Load More...
              </Link>
            </ActivityIndicator>
          )}
        </div>
      </ActivityIndicator>
    </div>
  );
};

export default DevelopmentNewsList;
